import React from 'react';

import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PracticeAreaCard = ({ practiceArea, currentLanguage }) => {
  return (
    <div className="card p-6 h-full flex flex-col hover:shadow-lg transition-all duration-200">
      <div className="flex items-center space-x-4 mb-4">
        <div className="flex items-center justify-center w-12 h-12 bg-gradient-to-br from-primary to-accent rounded-lg">
          <Icon name={practiceArea.icon} size={24} color="white" strokeWidth={2} />
        </div>
        <div className="flex-1">
          <h3 className="font-heading font-semibold text-lg text-text-primary">
            {practiceArea.name}
          </h3>
          <span className="text-sm text-text-secondary font-caption">
            {practiceArea.category}
          </span>
        </div>
      </div>

      <p className="text-text-secondary mb-4 flex-1 leading-relaxed">
        {practiceArea.description}
      </p>

      <div className="mb-4">
        <h4 className="font-medium text-text-primary mb-2 text-sm">
          {currentLanguage === 'en' ? 'Key Services:' : 'Huduma Kuu:'}
        </h4>
        <ul className="space-y-1">
          {practiceArea.keyServices.slice(0, 3).map((service, index) => (
            <li key={index} className="flex items-start space-x-2 text-sm text-text-secondary">
              <Icon name="Check" size={16} className="text-success mt-0.5 flex-shrink-0" />
              <span>{service}</span>
            </li>
          ))}
        </ul>
      </div>

      <div className="mb-6">
        <h4 className="font-medium text-text-primary mb-2 text-sm">
          {currentLanguage === 'en' ? 'Typical Cases:' : 'Kesi za Kawaida:'}
        </h4>
        <div className="flex flex-wrap gap-2">
          {practiceArea.typicalCases.slice(0, 2).map((caseType, index) => (
            <span
              key={index}
              className="px-2 py-1 bg-surface/20 text-primary text-xs rounded-full font-caption"
            >
              {caseType}
            </span>
          ))}
        </div>
      </div>

      <Button
        variant="outline"
        fullWidth
        iconName="ArrowRight"
        iconPosition="right"
        onClick={() => {
          window.location.href = `/individual-practice-area-detail?area=${practiceArea.slug}`;
        }}
      >
        {currentLanguage === 'en' ? 'Learn More' : 'Jifunze Zaidi'}
      </Button>
    </div>
  );
};

export default PracticeAreaCard;